<template>
  <div>
    <navigation-top/>

    <div class="d-flex justify-end ma-2">
      <settings-organisation-dialog
        ref="dialogOrganisation"
      />
    </div>

    <div class="ma-2" v-if="user">
      <v-data-table
        :headers="headersOrganisations"
        :items="organisations"
        :items-per-page="-1"
        :search="searchOrganisations"
        no-data-text="0 organisations, click on 'CREATE NEW ORGANISATION'!"
      >
        <template v-slot:bottom></template>
        <template #item="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td>{{ user.firstname + ' ' + user.lastname }} (you)</td>
            <td class="text-right">
              <v-menu>
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    variant="text"
                    icon
                    class="mr-2"
                    :disabled="subscriptionAccessType !== 'FULL'"
                  >
                    <v-icon>mds:more-horiz</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="editItemOrganisation(props.item)" prepend-icon="mds:edit">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="showDeleteOrganizationDialog(props.item)" prepend-icon="mds:delete">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-alert v-if="searchOrganisations?.length" color="error" icon="mdi-alert">
            Your search for "{{ searchOrganisations }}" found no results.
          </v-alert>
          <div v-else>
            No data available
          </div>
        </template>
      </v-data-table>
    </div>

    <delete-confirmation-dialog
      v-model="showDeleteDialog"
      title="Confirm organization deletion"
      text="Are you sure you want to delete this organisation?"
      :onDelete="deleteItemOrganisation"
    />

  </div>
</template>

<script>
import { EventBus } from '@/event-bus/event-bus.js'
import SettingsOrganisationDialog from '@/components/SettingsOrganisationDialog'
import NavigationTop from '@/components/NavigationTop'
import projectApi from '@/api/projectApi'
import { mapState, mapGetters } from 'vuex'
import DeleteConfirmationDialog from '@/components/DeleteConfirmationDialog'

export default {
  components: {
    NavigationTop,
    SettingsOrganisationDialog,
    DeleteConfirmationDialog
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 30 || 'Max 30 characters'
    },
    searchProjects: '',
    searchOrganisations: '',
    active: 'organisations',
    organizationToDelete: null,
    showDeleteDialog: false,
    headersOrganisations: [
      {
        title: 'Organisation',
        align: 'left',
        sortable: true,
        key: 'name'
      },
      {
        title: 'Owner',
        align: 'left',
        sortable: false
      },
      {
        title: '',
        align: 'center',
        sortable: false
      }
    ],
    headersProjects: [
      {
        title: 'Project',
        align: 'left',
        sortable: true,
        key: 'name'
      },
      {
        title: 'Organisation',
        align: 'left',
        sortable: true,
        key: 'organisationName'
      },
      {
        title: 'Owner',
        align: 'left',
        sortable: false
      },
      {
        title: '',
        align: 'center',
        sortable: false
      }
    ]
  }),

  computed: {
    ...mapState({
      organisations: state => state.organisations.organisations || [],
      projectMemberships: state => state.projectMemberships.projectMemberships,
      user: state => state.user.user,
      subscriptionAccessType: state => state.payments.subscriptionAccessType
    }),
    ...mapGetters({
      projects: 'projectMemberships/myProjects'
    })
  },
  methods: {
    setProject (item) {
      EventBus.$emit('set-project', item)
    },
    editItemOrganisation (item) {
      this.$refs.dialogOrganisation.setItem(Object.assign({}, item))
      this.$refs.dialogOrganisation.openOrganisationDialog()
    },
    editItemProject (item) {
      this.$refs.dialogProject.setItem(Object.assign({}, item))
      this.$refs.dialogProject.openProjectDialog()
    },
    showDeleteOrganizationDialog (item) {
      this.organizationToDelete = item
      this.showDeleteDialog = true
    },
    deleteItemOrganisation () {
      projectApi.deleteOrganisation(this.organizationToDelete)
    }
  }
}
</script>

<style scoped>
.setting-search-field {
  padding-top: 6px;
}

.hidden {
  display: none;
}

.active-project {
  font-weight: bold !important;
}
</style>
